import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ApiManagement, SideNav } from "./";
import { AdminRoute } from "./../../";
import PageWithSidebar from "components/PageWithSidebar";

import RegisteredAccounts from "pages/Admin/Accounts/RegisteredAccounts";
import AdminAccounts from "pages/Admin/Accounts/AdminAccounts";
import PendingInvites from "pages/Admin/Accounts/PendingInvites";
import PendingRequests from "pages/Admin/Accounts/PendingRequests";
import UnconfirmedUsers from "pages/Admin/Accounts/UnconfirmedUsers";
import Permission from "pages/Admin/Profiles/Permission";
import HostAdmin from "pages/Admin/Host";
import DeveloperInfo from "pages/Admin/DeveloperInfo";
import Profile from "./Profiles/Profile";
import Audit from "pages/Admin/Audit";

export class Admin extends Component {
  render() {
    return (
      <Router>
        <PageWithSidebar sidebarContent={<SideNav />}>
          <>
            <AdminRoute path="/admin/apis" component={ApiManagement} />
            <AdminRoute path="/admin/audit" component={Audit} />
            <AdminRoute path="/admin/hosts" component={HostAdmin} />
            <AdminRoute exact path="/admin/profiles" component={Profile} />
            <AdminRoute
              exact
              path="/admin/profiles/permissions"
              component={Permission}
            />
            <AdminRoute path="/admin/developerInfo" component={DeveloperInfo} />
            <AdminRoute
              exact
              path="/admin/accounts"
              component={RegisteredAccounts}
            />
            <AdminRoute
              exact
              path="/admin/accounts/admins"
              component={AdminAccounts}
            />
            <AdminRoute
              exact
              path="/admin/accounts/invites"
              component={PendingInvites}
            />
            <AdminRoute
              exact
              path="/admin/accounts/requests"
              component={PendingRequests}
            />
            <AdminRoute
              exact
              path="/admin/accounts/unconfirmed"
              component={UnconfirmedUsers}
            />
          </>
        </PageWithSidebar>
      </Router>
    );
  }
}
  